import { TechnicalSpecificsType } from "../../types";

export const getTechnicalSpecificsBooleanRoof = (
  technicalSpecifics: TechnicalSpecificsType
): string =>
  //  Boolean roof = 'open' | 'close'
  technicalSpecifics.roof === "" || technicalSpecifics.roof === "open"
    ? "_open"
    : "_close";
